var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center mt-2 text--secondary"},[_vm._v("ver:1.2.27")])}
var staticRenderFns = []

export { render, staticRenderFns }